import React, { useCallback, useEffect, useState, useRef } from "react";
import uncodedIcon from "../../../common/assets/images/uncoded.png";
import uncodedandassignIcon from "../../../common/assets/images/uncodedandassign.png";
import unassignedIcon from "../../../common/assets/images/unassigned.png";
import overDueIcon from "../../../common/assets/images/overdue.png";
import inprogressIcon from "../../../common/assets/images/inprogress.png";
import backIcon from "../../../common/assets/images/back-icon.png";
import userIcon from "../../../common/assets/images/user-icon.png";
import generalsurgeryIcon from "../../../common/assets/images/general-surgery-icon.png";
import workflowFilterIcon from "../../../common/assets/images/workflow-filter-icon.png";
import LdsRoller from "../../../utils/LdsRoller";
import closeIcon from "../../../common/assets/images/modal-close-icon.png";
import { toast, ToastContainer } from "react-toastify";
import {
  faSort,
  faSortAmountUp,
  faSortAmountDown,
} from "@fortawesome/free-solid-svg-icons";
import {
  Table,
  Badge,
  Form,
  Pagination,
  Dropdown,
  Button,
  Card,
  Placeholder,
  Spinner,
} from "react-bootstrap";
import "./HealthInformationManager.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { formatCalenderDate } from "../../CodingScreen/utils";
import { Box, Tooltip } from "@mui/material";
import {
  getHealthInformationQueueManagerEpisodes,
  updateFilters,
  updateComponentState,
  resetEpisodeAssignmentMessage,
  setAutoApplyUnassigned,
  setEpisodeIdentiferFilterSearch,
  setMRNFilterSearch,
  setQueueFilterSearch,
  setHealthFundFilterContractSearch,
  setPriorityFilterSearch,
  setSpecialityFilterSearch,
  setCoderFilterSearch,
  setProvisionalDrgFilterSearch,
  setStatusFilterSearch,
  getHealthInformationManagerQueuesData,
  getHealthInformationManagerUsersData,
  resetHimFilters,
  getHealthInformationManagerDashboardOptions,
  resetSideBarUsersData,
  getUncodedEpisodes, 
  setIsUncodedView,  
} from "./redux/HealthInformationManagerSlicer";
import { useDispatch, useSelector } from "react-redux";
import HealthInformationManagerAssignModal from "./HealthInformationManagerAssignModal";
import { debounce } from "lodash";
import search_icon from "../../../common/assets/images/search-icon-new.png";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "@mui/material";
import HealthSideDrawer from "./mobile/HealthSideDrawer";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import RefershIcon from "../../../common/assets/images/reload.png";
import HimManagerFilter from "./HimManagerFilter";
import LockOutlineIcon from "@mui/icons-material/LockOutline";
import { getunlockEpisode } from "../../pages/Coder/redux/CoderSlicer";
import { initialState } from "./redux/HealthInformationManagerSlicer";
import { fetchCdqHistoryResponse } from "../CoderView/redux/CoderScreenSlice";
import CdqResponseHistoryModal from "../CdqResponseHistoryModal/CdqResponseHistoryModal";
import {
  getWorkflowsCountData,
  getUnassignedCount,
  // getForAuditedCount,
} from "../CodeworkflowSlicer";

const HealthInformationManager = () => {
  // declaration
  const isMobile = useMediaQuery("(max-width: 1024px)");
  const dispatch = useDispatch();
  const codersContainerRef = useRef(null); 
  const lastRequestedPageRef = useRef(0);
  const dateFormat = "dd-MM-yyyy";
  const appliedFiltersRef = useRef();
  const navigate = useNavigate();
  const [isFilterDrawerOpen, setIsFilterDrawerOpen] = useState(false);
  const [showHimFilter, setShowHimFilter] = useState(false);
  const [searchType, setSearchType] = useState("episode"); // 'episode' | 'mrn'
  const [showOptions, setShowOptions] = useState(false);
  const [cdqPageNumber, setCdqPageNumber] = useState(1);
 const codebookcoblhEnv = process.env.REACT_APP_FLAG_COBLH_DEV;
 const codebookdevEnv = process.env.REACT_APP_FLAG_DEV;
  const isUncodedEnabledEnv = codebookdevEnv || codebookcoblhEnv;
  // selectors
  const { codesCountsData } = useSelector(
    (state) => state.codeWorkflow.workflowCount,
  );
  const filtersPayload = useSelector(
    (state) =>
      state.healthInsuranceManager.healthInformationManagerEpisodesPayload,
  );
  const isUncodedView = useSelector(
    (state) => state.healthInsuranceManager.isUncodedView,
  );
  const { episodeAssignmentResponse } = useSelector(
    (state) => state.healthInsuranceManager.healthInformationManagerAssignment,
  );
  const {
    healthInformationManagerData,
    healthInformationManagerLoading,
    healthInformationManagerError,
  } = useSelector(
    (state) => state.healthInsuranceManager.healthInformationManagerResponse,
  );
  const {
    loading: healthInformationManagerEpisodesLoading,
    data: healthInformationManagerEpisodesData,
    error: healthInformationManagerEpisodesError,
  } = useSelector(
    (state) => state.healthInsuranceManager.healthInformationManagerEpisodes,
  );
  const cdqHistoryData = useSelector(
      (state) => state.coderscreenqueue.cdqHistoryData,
    );
    const loadingCdqHistoryData = useSelector(
      (state) => state.coderscreenqueue.loadingCdqHistoryData,
    );
    const errorCdqHistoryData = useSelector(
      (state) => state.coderscreenqueue.errorCdqHistoryData,
    );

  const {
    loading: healthInformationManagerDashboardsLoading,
    data: healthInformationManagerDashboardsData,
    error: healthInformationManagerDashboardsError,
  } = useSelector(
    (state) => state.healthInsuranceManager.healthInformationManagerDashboards,
  );
  const uncodedEpisodesCount = healthInformationManagerDashboardsData?.cards?.["uncoded and assigned"] ?? 0;

  // --------------------------------------------------------------------------------------
  const {
    sideBarQueuesData,
    sideBarQueuesDataLoading,
    sideBarQueuesDataError,
  } = useSelector((state) => state.healthInsuranceManager.sideBarQueuesData);

  const autoApplyUnassigned = useSelector(
    (state) => state.healthInsuranceManager.autoApplyUnassigned,
  );
  const storedRole = sessionStorage.getItem("workspaceRole");

  // states
  const { selectedRecord } = useSelector(
    (state) =>
      state.healthInsuranceManager.healthInformationManagerComponentState,
  );
  const {
    sideBarAuditorsData,
    sideBarCodersData,
    sideBarUsersDatapageNumber,
    sideBarUsersDatahasMore,
    sideBarUsersDataLoading,
    sideBarUsersDataError,
  } = useSelector((state) => state.healthInsuranceManager.sideBarUsersData);
  const [episodesCurrentPage, setEpisodesCurrentPage] = useState(1);
  const isTouchDevice =
    typeof window !== "undefined" &&
    ("ontouchstart" in window || navigator.maxTouchPoints > 0);

  // const [filterEpisodes, setFilterEpisodes] = useState({
  //   separation_date_from: null,
  //   separation_date_to: null,
  //   speciality: [],
  //   queue: [],
  //   queue_priority: [],
  //   status: [],
  //   coders: [],
  //   // page_number: episodesCurrentPage,
  // });
  const [workflowHimsAssginModal, setWorkflowHimsAssginModal] = useState(false);
  const [episodesPerPage, setEpisodesPerPage] = useState(10);
  const [selectedHimEpisodes, setSelectedHimEpisodes] = useState([]);
  const [isAllEpisodesSelected, setIsAllEpisodesSelected] = useState(false);
  const [showFilterSection, setShowFilterSection] = useState(true);
  const [appliedFilterModal, setAppliedFilterModal] = useState(false);
  const [episodesData, setEpisodesData] = useState([]);
  const [uncheckedIds, setUncheckedIds] = useState([]);

  // const totalPages = episodesPerPage > 0 ? Math.ceil(episodesData?.length / episodesPerPage) : 0;
  const totalPages =
    typeof healthInformationManagerEpisodesData?.meta?.total_episode_count ===
      "number" &&
    typeof filtersPayload?.page_size === "number" &&
    filtersPayload.page_size > 0
      ? Math.max(
          1,
          Math.ceil(
            healthInformationManagerEpisodesData?.meta?.total_episode_count /
              filtersPayload.page_size,
          ),
        )
      : 1;
  // const indexOfLastEpisode = episodesCurrentPage * episodesPerPage;
  // const indexOfFirstEpisode = indexOfLastEpisode - episodesPerPage;
  // const currentEpisodesList = episodesData?.slice(indexOfFirstEpisode, indexOfLastEpisode);
  const [selectedDrgMap, setSelectedDrgMap] = useState({});
  const [drgAnchorEl, setDrgAnchorEl] = useState(null);
  const [activeDrgRow, setActiveDrgRow] = useState(null);
  const [coderSearchTerm, setCoderSearchTerm] = useState("");
  const [selectedCoderOptions, setSelectedCoderOptions] = useState([]);
  const [selectedCdqRecord, setSelectedCdqRecord] = useState(null);
  const [showCdqModal, setShowCdqModal] = useState(false);
  const getSelectedDrgIndex = (hcpLineId) => selectedDrgMap[hcpLineId] ?? 0;

  const CDQ_PAGE_SIZE = 4
    const handleViewCdqResponses = (episodeItem) => {
      setSelectedCdqRecord(episodeItem);
      setShowCdqModal(true);
      dispatch(
        fetchCdqHistoryResponse({
          hcp_line_id: episodeItem?.hcp_line_id,
          role:storedRole,
          page_number: 1
        }),
      );
    };
   const handleCdqPageChange = (nextPage) => {
      if (nextPage < 1) return;
      setCdqPageNumber(nextPage);
      dispatch(
        fetchCdqHistoryResponse({
          hcp_line_id: selectedCdqRecord?.hcp_line_id,
           role:storedRole,
          page_number: nextPage,
          // page_size: CDQ_PAGE_SIZE,
        }),
      );
    };

    const handleCloseCdqModal = () => {
    setShowCdqModal(false);
    setSelectedCdqRecord(null);
  };

  const updateSelectedDrgIndex = (hcpLineId, index) => {
    setSelectedDrgMap((prev) => ({
      ...prev,
      [hcpLineId]: index,
    }));
  };

  const openDrgMenu = (event, hcpLineId) => {
    setDrgAnchorEl(event.currentTarget);
    setActiveDrgRow(hcpLineId);
  };

  const closeDrgMenu = () => {
    setDrgAnchorEl(null);
    setActiveDrgRow(null);
  };

  const dataToDisplay = episodesData?.length > 0 && episodesData;
  const codingDashboardOptions =
    healthInformationManagerDashboardsData?.cards &&
    Object.keys(healthInformationManagerDashboardsData?.cards)
    ?.filter((item) => {
      if (item === "uncoded and assigned") {
        return isUncodedEnabledEnv;
      }
      return true;
    })
    ?.map((item) => {
      return {
        name:
          item === "uncoded"
            ? storedRole === "coder"
              ? "Uncoded"
              : "Unaudited"
            : item === "unaudited"
              ? "Unaudited"
              : item === "unassigned"
                ? "Unassigned"
                : item === "overdue"
                  ? "Overdue"
                  : item === "in_progress"
                    ? "Inprogress"
                    : item === "uncoded and assigned"
                      ? "Assigned Uncoded"
                      : "",
        // count:item === "uncoded" ? apiResponse.episodes.filter((ep) => ep === "uncoded").length : item === "unassigned" ? apiResponse.episodes.filter((ep) => ep === "unassigned").length : item === "overdue" ? apiResponse.episodes.filter((ep) => ep === "overdue").length : item === "in_progress" ? apiResponse.episodes.filter((ep) => ep === "in_progress").length : 0,
        count: healthInformationManagerDashboardsData.cards[item],
        // count: item === "uncoded" ? "256" : item === "unassigned" ? "196" : item === "overdue" ? "2" : item === "In progress" ? "65" : "0",
        icon:
          item === "uncoded" || item === "unaudited"
            ? uncodedIcon
            : item === "unassigned"
              ? unassignedIcon
              : item === "overdue"
                ? overDueIcon
                : item === "in_progress"
                  ? inprogressIcon
                     : item === "uncoded and assigned"
                      ? uncodedandassignIcon 
                      : "",
        tooltipContent:
          item === "uncoded"
            ? "You have 10 uncoded episodes awaiting coding"
            : item === "unassigned"
              ? "You have 10 unassigned episodes pending allocation"
              : item === "overdue"
                ? "You have 10 episodes that are overdue for completion"
                : item === "in_progress"
                  ? "You have 10 ongoing episodes in progress"
                   : item === "uncoded and assigned"
                    ? "You have episodes that are uncoded and assigned"
                    : "",
        backgroundColor:
          item === "uncoded" || item === "unaudited"
            ? "#EFF6FF"
            : item === "unassigned"
              ? "#FEF2F2"
              : item === "overdue"
                ? "#FEFCE8"
                : item === "in_progress"
                  ? "#ECFDF5"
                   : item === "uncoded and assigned"
                    ? "#fcf4d3"
                    : "",
      };
    });

  const handlePageChange = (pageNumber) => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      const payload = {
        ...filtersPayload,
        page_number: pageNumber,
      };
      // dispatch(getHealthInformationQueueManagerEpisodes({storedRole, ...payload}));
      if (isUncodedView && isUncodedEnabledEnv) {
      dispatch(getUncodedEpisodes({ ...payload, screen_type: storedRole }));
    } else {
      dispatch(getHealthInformationQueueManagerEpisodes({ storedRole, ...payload }));
    }
      dispatch(getHealthInformationManagerDashboardOptions({...payload, screen_type: storedRole}));
      dispatch(updateFilters(payload));
      // setEpisodesCurrentPage(pageNumber);
    }
  };

  const handleRowsPerPageChange = (event) => {
    const payload = {
      ...filtersPayload,
      page_number: 1,
      page_size: Number(event.target.value),
    };
    // dispatch(getHealthInformationQueueManagerEpisodes({storedRole, ...payload}));
    if (isUncodedView && isUncodedEnabledEnv) {
      dispatch(getUncodedEpisodes({ ...payload, screen_type: storedRole }));
    } else {
      dispatch(getHealthInformationQueueManagerEpisodes({ storedRole, ...payload }));
    }
    dispatch(getHealthInformationManagerDashboardOptions({...payload, screen_type: storedRole}))
    dispatch(updateFilters(payload));
    // setEpisodesCurrentPage(1);
    // setEpisodesPerPage(Number(event.target.value));
  };

  const hanldeSelectAllHimEpisodes = (event) => {
    const allSelectedEpisodes = episodesData?.map((item) => item);
    if (event && event.target.checked) {
      setSelectedHimEpisodes(allSelectedEpisodes);
      setUncheckedIds([]);
      setIsAllEpisodesSelected(true);
    } else {
      setSelectedHimEpisodes([]);
      setIsAllEpisodesSelected(false);
    }
  };
  console.log(sideBarCodersData, "sideBarUsersData", sideBarUsersDataError);

    const handleSelectedEpisodesOnLeftQueuesClicked = () => {
    setSelectedHimEpisodes([]);
    setIsAllEpisodesSelected(false);
    };

  useEffect(() => {
    if (isAllEpisodesSelected && episodesData?.length > 0) {
      const newSelected = episodesData.filter(
        (item) => !uncheckedIds.includes(item.hcp_line_id),
      );

      const uniqueSelected = [
        ...selectedHimEpisodes,
        ...newSelected.filter(
          (item) =>
            !selectedHimEpisodes.some(
              (s) => s.hcp_line_id === item.hcp_line_id,
            ),
        ),
      ];

      setSelectedHimEpisodes(uniqueSelected);
    }
  }, [episodesData, isAllEpisodesSelected, uncheckedIds]);
  //when user leaves the HIM workspace clears the Filters state
  useEffect(() => {
    return () => {
      dispatch(resetHimFilters());
    };
  }, [dispatch]);
  useEffect(() => {
    dispatch(getWorkflowsCountData());
    // });
  }, []);
  // const handleHimRowSelection = (event, HimEpisodeItem) => {
  //   dispatch(updateComponentState(HimEpisodeItem))
  //   // setSelectedRecord(HimEpisodeItem)
  //   if (event.target.checked) {
  //     const selectedData = [...selectedHimEpisodes, HimEpisodeItem?.hcp_line_id];
  //     setSelectedHimEpisodes(selectedData);
  //   } else {
  //     if(isAllEpisodesSelected){
  //       const newUnassignedData = selectedHimEpisodes.filter(
  //         (epsoideId) => epsoideId === HimEpisodeItem?.hcp_line_id
  //       );
  //       console.log(newUnassignedData, 'newUnassignedData')
  //     }

  //     const newAssignedData = selectedHimEpisodes.filter(
  //       (epsoideId) => epsoideId !== HimEpisodeItem?.hcp_line_id
  //     );
  //     setSelectedHimEpisodes(newAssignedData);
  //   }
  // };

  const handleHimRowSelection = (event, HimEpisodeItem) => {
    dispatch(updateComponentState(HimEpisodeItem));
    if (event.target.checked) {
      const selectedData = [...selectedHimEpisodes, HimEpisodeItem];
      setSelectedHimEpisodes(selectedData);
      // setUncheckedIds(uncheckedIds.filter(id => id !== HimEpisodeItem?.hcp_line_id));
    } else {
      if (isAllEpisodesSelected) {
        const newUnassignedData = selectedHimEpisodes.filter(
          (episodeId) => episodeId?.hcp_line_id === HimEpisodeItem?.hcp_line_id,
        );
        setUncheckedIds([...uncheckedIds, HimEpisodeItem?.hcp_line_id]);
      }
      const newAssignedData = selectedHimEpisodes.filter(
        (episodeId) => episodeId?.hcp_line_id !== HimEpisodeItem?.hcp_line_id,
      );
      setSelectedHimEpisodes(newAssignedData);
    }
  };

  const handleHimSelectChange = (fieldName, value) => {
    const currentValues = filtersPayload[fieldName] || [];
    let updatedValues = [];

    if (Array.isArray(value)) {
      updatedValues = value;
    } else {
      updatedValues = currentValues.includes(value)
        ? currentValues.filter((item) => item !== value)
        : [...currentValues, value];
    }

    const updatedFilters = {
      ...filtersPayload,
      page_number: 1,
      [fieldName]: updatedValues,
    };
    dispatch(updateFilters(updatedFilters));
    dispatch(getHealthInformationQueueManagerEpisodes({storedRole, ...updatedFilters}));
    dispatch(getHealthInformationManagerDashboardOptions({...updateFilters, screen_type: storedRole} ))
  };

  const handleHimDatePickerChange = (fieldName, date) => {
    let filteredData = episodesData;

    const updatedFilters = {
      ...filtersPayload,
      page_number: 1,
      [fieldName === fieldName ? fieldName : fieldName]:
        formatCalenderDate(date),
    };

    if (updatedFilters.separation_date_from) {
      filteredData = filteredData.filter(
        (item) =>
          item.separation_date_from === updatedFilters.separation_date_from,
      );
    }

    if (updatedFilters.separation_date_to) {
      filteredData = filteredData.filter(
        (item) => item.separation_date_to === updatedFilters.separation_date_to,
      );
    }
    dispatch(updateFilters(updatedFilters));
    dispatch(getHealthInformationQueueManagerEpisodes({storedRole, ...updatedFilters}));
    dispatch(getHealthInformationManagerDashboardOptions({...updateFilters, screen_type: storedRole}))
    // setFilterEpisodes(updatedFilters);
    // setEpisodesData(filteredData);
  };

  const hanldeSelectQueueEpisodes = (type, data) => {
    if (type === "queue") {
      const payload = {
        ...initialState.healthInformationManagerEpisodesPayload,
        page_number: 1,
        coder_ids: [],
        queue_ids: [data.queue_id],
      };
      setSelectedHimEpisodes([]);
      dispatch(setIsUncodedView(false)); 
      setIsAllEpisodesSelected(false);
      dispatch(updateFilters(payload));
      dispatch(getHealthInformationQueueManagerEpisodes({storedRole, ...payload}));
      dispatch(getHealthInformationManagerDashboardOptions({...payload, screen_type: storedRole}));
    }
    // NEW: Uncoded - same as "queue" flow, but queue_ids key is never added
    if (type === "uncoded") {
      dispatch(setIsUncodedView(true));
      const payload = {
        ...initialState.healthInformationManagerEpisodesPayload,
        page_number: 1,
        coder_ids: [],
        // queue_ids intentionally omitted here
      };
      setSelectedHimEpisodes([]);
      setIsAllEpisodesSelected(false);
      dispatch(updateFilters(payload));
      // dispatch(getHealthInformationQueueManagerEpisodes({ storedRole, ...payload }));
      dispatch(getUncodedEpisodes({...payload, screen_type:storedRole})); // NEW thunk, not getHealthInformationQueueManagerEpisodes
      dispatch(getHealthInformationManagerDashboardOptions({ ...payload, screen_type: storedRole}));
    }
    if (type === "coder") {
      const payload = {
        ...initialState.healthInformationManagerEpisodesPayload,
        page_number: 1,
        queue_ids: [],
        coder_ids: [data.user_id],
      };
      setIsAllEpisodesSelected(false);
      setSelectedHimEpisodes([]);
      dispatch(updateFilters(payload));
      dispatch(setIsUncodedView(false));
      dispatch(getHealthInformationQueueManagerEpisodes({storedRole, ...payload}));
      dispatch(getHealthInformationManagerDashboardOptions({...payload, screen_type: storedRole}));
    }
    if (type === "auditor") {
      const payload = {
        ...initialState.healthInformationManagerEpisodesPayload,
        page_number: 1,
        queue_ids: [],
        coder_ids: [data.user_id],
      };
      setSelectedHimEpisodes([]);
      dispatch(setIsUncodedView(false));
      dispatch(updateFilters(payload));
      dispatch(getHealthInformationQueueManagerEpisodes({storedRole, payload}));
      dispatch(getHealthInformationManagerDashboardOptions({...payload, screen_type: storedRole}));
    }
    setSelectedCoderOptions([
      {
        value: data.user_id,
        label: data.user_name,
      },
    ]);
      setCoderSearchTerm("");
  };

  const renderDropdownOptions = (type, options, selected, searchValue) => {
    return options
      ?.filter((item) => item.toLowerCase().includes(searchValue.toLowerCase()))
      .map((item) => (
        <Form.Check
          key={item}
          type="checkbox"
          className="workflow-him-dropdown-menu-options"
          label={item}
          value={item}
          checked={selected?.includes(item)}
          onChange={() => handleHimSelectChange(type, item)}
        />
      ));
  };

  const handleDragStart = (e, item) => {
    e.dataTransfer.setData("application/json", JSON.stringify(item));
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e, selectedName, type) => {
    e.preventDefault();
    const item = JSON.parse(e.dataTransfer.getData("application/json"));
    setWorkflowHimsAssginModal(true);
    let selectedEpisodeToTransfer = {};
    if (type === "queues") {
      selectedEpisodeToTransfer = { ...item, queue_ids: selectedName };
    }
    if (type === "coders") {
      selectedEpisodeToTransfer = { ...item, assigned_user: selectedName };
    }
    dispatch(updateComponentState(selectedEpisodeToTransfer));
  };

  const handleFilterRemove = (filterName, item) => {
    const updatedFilterObj = { ...filtersPayload };
    if (Array.isArray(updatedFilterObj[filterName])) {
      updatedFilterObj[filterName] = updatedFilterObj[filterName].filter(
        (value) => value !== item,
      );
    } else {
      updatedFilterObj[filterName] = filterName === "date" ? null : "";
    }
    dispatch(updateFilters(updatedFilterObj));
    dispatch(getHealthInformationQueueManagerEpisodes({storedRole, ...updatedFilterObj}));
    dispatch(getHealthInformationManagerDashboardOptions({...payload, screen_type: storedRole}));
    // setFilterEpisodes(updatedFilterObj);
  };

  const keysToRemove = ["page_number", "page_size"];
  const newObj = { ...filtersPayload };
  keysToRemove.forEach((key) => {
    delete newObj[key];
  });
  const hasValue = Object.values(newObj).some(
    (item) =>
      item !== "" &&
      item !== null &&
      (Array.isArray(item) ? item.length > 0 : true),
  );

  useEffect(() => {
    // filter options on first render
    // Normal page load
    if (!autoApplyUnassigned) {
         if (isUncodedView && isUncodedEnabledEnv) {
            dispatch(setIsUncodedView(true)); 
      dispatch(getUncodedEpisodes({ ...filtersPayload, screen_type: storedRole }));
      }else{
        dispatch(
         getHealthInformationQueueManagerEpisodes({
          storedRole,
          ...filtersPayload,
        })
        );
      }
        dispatch(
        getHealthInformationManagerDashboardOptions({
          ...filtersPayload,
          screen_type: storedRole
        }))
        
      return;
    }
    //(Unassigned Episodes Filter)
    const payload = {
      ...filtersPayload,
      // coder_ids: [0], //unassigned Logic
    };

    dispatch(updateFilters(payload));

  if (isUncodedView && isUncodedEnabledEnv) {
    dispatch(getUncodedEpisodes({ ...payload, screen_type: storedRole }));
  }else{
    dispatch(getHealthInformationQueueManagerEpisodes({storedRole, ...payload}));
}
    dispatch(getHealthInformationManagerDashboardOptions({...payload, screen_type: storedRole}));
  }, [autoApplyUnassigned]);

  useEffect(() => {
    setEpisodesData(healthInformationManagerEpisodesData.episodes);
  }, [healthInformationManagerEpisodesData]);

  useEffect(() => {
    if (episodeAssignmentResponse.message) {
      toast.success("Assigned episodes successfully");
      const resetState = {
        separation_date_from: null,
        separation_date_to: null,
        admission_date_from: null,
        admission_date_to: null,
        speciality_ids: [],
        queue_ids: [],
        priority: [],
        status_ids: [],
        coder_ids: [],
        page_number: 1,
        page_size: 10,
        episode_identifier_search: [],
        los: [],
        los_op: "",
        health_fund_contract: [],
        medical_record_number: [],
        drg_code: [],
        sort_by: [],
        sort_order: [],
        is_global_search: false,
      };
      dispatch(setIsUncodedView(false));
      dispatch(getHealthInformationQueueManagerEpisodes({storedRole, ...resetState}));
      dispatch(getHealthInformationManagerDashboardOptions({...resetState, screen_type: storedRole}));
      dispatch(updateFilters(resetState));
      setSelectedHimEpisodes([]);
      setIsAllEpisodesSelected(false);
      setWorkflowHimsAssginModal(false);
      setCoderSearchTerm("");
    }
    // dispatch(updateComponentState({}))
    dispatch(resetEpisodeAssignmentMessage());
  }, [episodeAssignmentResponse]);

  const debounceSearchHandler = useCallback(
    debounce((payload) => {
        if (isUncodedView && isUncodedEnabledEnv) {
      dispatch(getUncodedEpisodes({ ...payload, screen_type: storedRole }));
    } else {
      dispatch(getHealthInformationQueueManagerEpisodes({ storedRole, ...payload }));
    }
      // dispatch(getHealthInformationQueueManagerEpisodes({storedRole, ...payload}));
      dispatch(getHealthInformationManagerDashboardOptions({...payload, screen_type: storedRole}));
    }, 1000),
    [isUncodedView,isUncodedEnabledEnv],
  );

  const formatValue = (val) => {
  if (typeof val !== "string") return "";

  return val
    .trim()              // remove start/end spaces
    .replace(/\s+/g, " "); // convert multiple spaces → single space
};
  

 const handleSearchEpisode = (e) => {
  const rawValue = e.target.value;
  setCoderSearchTerm(rawValue);
  setShowOptions(false);

  const formattedValue = formatValue(rawValue);

  const payload = {
    ...filtersPayload,
    page_number: 1,
    is_global_search: true,
    episode_identifier_search:
      searchType === "episode" && formattedValue ? [formattedValue] : [],
    medical_record_number:
      searchType === "mrn" && formattedValue ? [formattedValue] : [],
  };

  // ✅ Use RAW value for UI state (if needed separately)
  dispatch(
    updateFilters({
      ...filtersPayload,
      page_number: 1,
      is_global_search: true,
      episode_identifier_search:
        searchType === "episode" ? [rawValue] : [],
      medical_record_number:
        searchType === "mrn" ? [rawValue] : [],
    })
  );

  // ✅ Use formatted value ONLY for API
  debounceSearchHandler(payload);
};

  const handleSearchTypeChange = (type) => {
    setSearchType(type);
    setShowOptions(false);

    dispatch(
      updateFilters({
        ...filtersPayload,
        episode_identifier_search: [],
        medical_record_number: [],
        is_global_search: false,
        page_number: 1,
      }),
    );
  };

  const getHighlightedText = (text) => {
    const fullText = text || "";
    const searchValue = filtersPayload?.episode_identifier_search;
    // Normalize to array
    const searchArray = Array.isArray(searchValue)
      ? searchValue
      : searchValue
        ? [searchValue]
        : [];
    if (!searchArray.length) return fullText;
    let highlightedText = fullText;
    searchArray.forEach((search) => {
      if (!search) return;
      // Escape special regex characters
      const escapedSearch = search?.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      const regex = new RegExp(`(${escapedSearch})`, "gi");
      highlightedText = highlightedText?.replace(
        regex,
        `<span style="background-color: yellow;">$1</span>`,
      );
    });
    return <span dangerouslySetInnerHTML={{ __html: highlightedText }} />;
  };

  useEffect(() => {
    if (appliedFilterModal) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [appliedFilterModal]);
  useEffect(() => {
    dispatch(getHealthInformationManagerQueuesData({
        screen_type: storedRole === "coder" ? "U" : "AU",
    }));
    // dispatch(
    //   getHealthInformationManagerUsersData({
    //     screen_type: storedRole === "coder" ? "U" : "AU",
    //     page_number: sideBarUsersDatapageNumber + 1,
    //     limit: 10,
    //   }),
    // );
    return () => {
      toast.dismiss();
    };
  }, []);
  const handleScroll = (e) => {
    console.log("aSDFGDSEAwasdfgd");

    const { scrollTop, scrollHeight, clientHeight } = e.target;

    // Check if scrollbar exists
    const hasScrollbar = scrollHeight > clientHeight;
    console.log("triggered", hasScrollbar);

    if (!hasScrollbar) return;

    // Trigger only when reaching bottom
    if (scrollHeight - scrollTop <= clientHeight + 100) {
      console.log("triggered");

      if (sideBarUsersDatahasMore && !sideBarUsersDataLoading) {
        dispatch(
          getHealthInformationManagerUsersData({
            screen_type: storedRole === "coder" ? "U" : "AU",
            page_number: sideBarUsersDatapageNumber + 1,
            limit: 10,
          }),
        );
      }
    }
  };
useEffect(() => {
  if (lastRequestedPageRef.current === 1) return;  // ADDED
  lastRequestedPageRef.current = 1;                 // ADDED
  dispatch(resetSideBarUsersData());
  dispatch(
    getHealthInformationManagerQueuesData({
      screen_type: storedRole === "coder" ? "U" : "AU",
    }),
  );
  dispatch(
    getHealthInformationManagerUsersData({
      screen_type: storedRole === "coder" ? "U" : "AU",
      page_number: 1,
      limit: 10,
    }),
  );
  return () => toast.dismiss();
}, [storedRole, dispatch]);

useEffect(() => {
  const el = codersContainerRef.current;
  if (!el) return;
  const hasScrollbar = el.scrollHeight >= el.clientHeight;
  console.log("triggering....................");

  const nextPage = sideBarUsersDatapageNumber + 1;

  if (nextPage === lastRequestedPageRef.current) return;

  if (hasScrollbar && sideBarUsersDatahasMore && !sideBarUsersDataLoading) {
     lastRequestedPageRef.current = nextPage;
    dispatch(
      getHealthInformationManagerUsersData({
        screen_type: storedRole === "coder" ? "U" : "AU",
        // page_number: sideBarUsersDatapageNumber + 1,
         page_number: nextPage,
        limit: 10,
      }),
    );
  }
}, [
  sideBarCodersData,
  sideBarUsersDatahasMore,
  sideBarUsersDataLoading,
  sideBarUsersDatapageNumber,
  dispatch,
]);



  const handleClickOutside = (event) => {
    if (
      appliedFiltersRef.current &&
      !appliedFiltersRef.current.contains(event.target)
    ) {
      setAppliedFilterModal(false);
    }
  };

  const handleUnlockEpisode = (hcp_line_id) => {
    dispatch(getunlockEpisode({ hcp_line_id }))
      .unwrap()
      .then((res) => {
        toast.success(res?.message || "Episode unlocked successfully");
        // Re-fetch episodes instead of reload
        window.location.reload();
      })

      .catch((err) => {
        toast.error(err?.message);
      });
  };

  const handleModalClose = () => {
    setShowHimFilter(false);
    dispatch(resetHimFilters());
    dispatch(setEpisodeIdentiferFilterSearch(""));
    dispatch(setMRNFilterSearch(""));
    dispatch(setSpecialityFilterSearch(""));
    dispatch(setQueueFilterSearch(""));
    dispatch(setCoderFilterSearch(""));
    dispatch(setPriorityFilterSearch(""));
    dispatch(setStatusFilterSearch(""));
    dispatch(setHealthFundFilterContractSearch(""));
    dispatch(setProvisionalDrgFilterSearch(""));
    setCoderSearchTerm("");
    const resetState = {
      separation_date_from: null,
      separation_date_to: null,
      admission_date_from: null,
      admission_date_to: null,
      speciality_ids: [],
      queue_ids: [],
      priority: [],
      status_ids: [],
      coder_ids: [],
      page_number: 1,
      page_size: 10,
      episode_identifier_search: [],
      los: [],
      los_op: "",
      health_fund_contract: [],
      medical_record_number: [],
      drg_code: [],
      sort_by: [],
      sort_order: [],
      is_global_search: false,
    };
    if (isUncodedView && isUncodedEnabledEnv) {         
      dispatch(getUncodedEpisodes({ ...resetState, screen_type: storedRole }));
    } else {
      dispatch(getHealthInformationQueueManagerEpisodes({ storedRole, ...resetState }));
    }
    // dispatch(getHealthInformationQueueManagerEpisodes({storedRole, ...resetState}));
    dispatch(getHealthInformationManagerDashboardOptions({...resetState, screen_type: storedRole}));
  };

  const handleSort = (columnKey) => {
    const currentSortBy = filtersPayload.sort_by?.[0];
    const currentSortOrder = filtersPayload.sort_order?.[0];

    let order = "asc";

    if (currentSortBy === columnKey && currentSortOrder === "asc") {
      order = "desc";
    }

    const updatedFilters = {
      ...filtersPayload,
      sort_by: [columnKey],
      sort_order: [order],
      page_number: 1,
    };

    dispatch(updateFilters(updatedFilters));
    // dispatch(getHealthInformationQueueManagerEpisodes({storedRole, ...updatedFilters}));
     if (isUncodedView && isUncodedEnabledEnv) {
    dispatch(getUncodedEpisodes({ ...updatedFilters, screen_type: storedRole }));
  } else {
    dispatch(getHealthInformationQueueManagerEpisodes({ storedRole, ...updatedFilters }));
  }
    dispatch(getHealthInformationManagerDashboardOptions({...updatedFilters, screen_type: storedRole}));
  };
  const renderSortIcon = (columnKey) => {
    const currentSortBy = filtersPayload.sort_by?.[0];
    const currentSortOrder = filtersPayload.sort_order?.[0];

    if (currentSortBy !== columnKey) {
      return faSort; // neutral
    }

    return currentSortOrder === "asc" ? faSortAmountUp : faSortAmountDown;
  };
  const getSortTooltip = (columnKey) => {
    const currentSortBy = filtersPayload.sort_by?.[0];
    const currentSortOrder = filtersPayload.sort_order?.[0];

    if (currentSortBy !== columnKey) {
      return "Click to sort";
    }

    return currentSortOrder === "asc"
      ? "Sorted Ascending"
      : "Sorted Descending";
  };


   useEffect(() => {
  const updatePageSize = () => {
    const screenHeight = window.innerHeight;

    const reservedHeight = 360;

    const rowHeight = 36;

    const availableHeight =
      screenHeight - reservedHeight;

    const dynamicRows = Math.floor(
      availableHeight / rowHeight
    );

    const finalPageSize =
      dynamicRows > 10 ? dynamicRows : 10;

    setEpisodesPerPage(finalPageSize);

    const payload = {
      ...filtersPayload,
      page_number: 1,
      page_size: finalPageSize,
    };

    dispatch(updateFilters(payload));
    if (isUncodedView && isUncodedEnabledEnv) {
      dispatch(getUncodedEpisodes({ ...payload, screen_type: storedRole }));
    }else{
    dispatch(
      getHealthInformationQueueManagerEpisodes({
        storedRole,
        ...payload,
      })
    );
  }

    dispatch(
      getHealthInformationManagerDashboardOptions({
        ...payload,
        screen_type: storedRole,
      })
    );
  };

  updatePageSize();

  window.addEventListener(
    "resize",
    updatePageSize
  );

  return () => {
    window.removeEventListener(
      "resize",
      updatePageSize
    );
  };
}, [isUncodedView, isUncodedEnabledEnv]);

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />
      <div className="workflow-him-container">
        {!isMobile && (
          <div
            lg="3"
            sm="12"
            xs="12"
            md="12"
            className="left-him-workflow-card"
          >
            <div className="left-him-workflow-card-header">
              <img
                src={backIcon}
                className="left-him-workflow-card-icon"
                onClick={() => navigate("/Code-Workflow")}
              />
              <p className="left-him-workflow-card-text">Back to Workflow</p>
            </div>
            <div className="left-him-workflow-queues-card">
              <div className="him-queues-sections">
                <p className="left-him-workflow-queues-card-header">Queues</p>
                <div className="him-workflow-queues-container">
                  {sideBarQueuesDataLoading ? (
                    <div className="left-him-workflow-queues-card-top">
                      <div style={{ width: "100%", minHeight: "300px" }}>
                        <Placeholder animation="glow">
                          <Placeholder xs={12} className="queuePlaceholder" />
                        </Placeholder>
                      </div>
                    </div>
                  ) : sideBarQueuesDataError ? (
                    <div className="left-him-workflow-queues-error">
                      No queues found
                    </div>
                  ) : (
                    // Sort headers by priority
                    Object.entries(sideBarQueuesData?.queues || {})
                      .sort(([headerA, queuesA], [headerB, queuesB]) => {
                        const prioritiesA = queuesA
                          .map((q) => q.priority)
                          .filter((p) => p !== undefined);
                        const prioritiesB = queuesB
                          .map((q) => q.priority)
                          .filter((p) => p !== undefined);

                        const minPriorityA =
                          prioritiesA.length > 0
                            ? Math.min(...prioritiesA)
                            : 999;
                        const minPriorityB =
                          prioritiesB.length > 0
                            ? Math.min(...prioritiesB)
                            : 999;

                        return minPriorityA - minPriorityB;
                      })
                      .map(([header, queues]) => (
                        <>
                          <div
                            style={{
                              padding: "2px",
                              fontWeight: 700,
                              fontSize: "12px",
                              color: "#6b7280",
                            }}
                          >
                            {header}
                          </div>
                          {[...queues]
                            .sort(
                              (a, b) =>
                                (a.priority || 999) - (b.priority || 999),
                            )
                            .map((queriesItem) => (
                              <div
                                className="left-him-workflow-queues-card-top"
                                key={queriesItem?.queue_id}
                                onDragOver={handleDragOver}
                                onDrop={(e) =>
                                  handleDrop(
                                    e,
                                    queriesItem?.queue_name,
                                    "queues",
                                  )
                                }
                                onClick={() =>
                                  hanldeSelectQueueEpisodes(
                                    "queue",
                                    queriesItem,
                                  )
                                }
                              >
                                <p className="left-him-workflow-queues-card-icon">
                                  <img
                                    src={generalsurgeryIcon}
                                    alt={queriesItem?.queue_id}
                                  />
                                </p>
                                <p className="left-him-workflow-queues-card-name">
                                  <Tooltip title={queriesItem?.queue_name}>
                                    {`${queriesItem?.queue_name?.charAt(0)?.trim()?.toUpperCase()}${queriesItem?.queue_name?.trim()?.slice(1)}`}
                                  </Tooltip>
                                </p>
                                <p className="left-him-workflow-queues-card-count">
                                  <Tooltip
                                    title={`Total records: ${queriesItem?.total_number_of_episodes}`}
                                  >
                                    {`(${queriesItem?.total_number_of_episodes})`}
                                  </Tooltip>
                                </p>
                              </div>
                            ))}
                          {/* Manually added Uncoded queue - frontend only, right after Very high in CODER group */}
                          {header === "CODER" && isUncodedEnabledEnv && (
                            <div
                              className="left-him-workflow-queues-card-top"
                              onClick={() =>
                                hanldeSelectQueueEpisodes("uncoded", {})}
                            >
                              <p className="left-him-workflow-queues-card-icon">
                                <img src={generalsurgeryIcon} alt="uncoded" />
                              </p>
                              <p className="left-him-workflow-queues-card-name" style={{
                                // color: "#2563eb",
                                // textDecoration: "underline",
                                cursor: "pointer",
                              }}>
                                <Tooltip title="Uncoded">Uncoded</Tooltip>
                              </p>
                              <p className="left-him-workflow-queues-card-count">
                                <Tooltip title={`Total records: ${uncodedEpisodesCount}`}>
                                  {`(${uncodedEpisodesCount})`}
                                </Tooltip>
                              </p>
                            </div>
                          )}
                        </>
                      ))
                  )}
                </div>
              </div>
              <div className="him-coders-sections" onScroll={handleScroll}>
                <p className="left-him-workflow-coders-card-header">
                  {" "}
                  {storedRole === "coder" ? "Coders" : "Auditors"}{" "}
                </p>
                <div
                  className="him-workflow-coders-container"
                  ref={codersContainerRef}
                >
                  {
                    sideBarUsersDataLoading ? (
                      <div className="left-him-workflow-coders-card-top">
                        {/* <LdsRoller/>  */}
                        <div
                          className=""
                          style={{ width: "100%", minHeight: "300px" }}
                        >
                          <Placeholder animation="glow">
                            <Placeholder xs={12} className="queuePlaceholder" />
                          </Placeholder>
                        </div>
                      </div>
                    ) : sideBarUsersDataError ? (
                      <div className="left-him-workflow-coders-error">
                        {" "}
                        {storedRole === "coder"
                          ? "No coders found"
                          : "No auditors found"}{" "}
                      </div>
                    ) : (
                      // storedRole === "coder" ? (
                      sideBarCodersData?.map((item) => (
                        <div
                          className="left-him-workflow-coders-card-top"
                          key={item?.user_id}
                          onDragOver={handleDragOver}
                          onDrop={(e) =>
                            handleDrop(e, item?.user_name, "coders")
                          }
                          onClick={() =>
                            hanldeSelectQueueEpisodes("coder", item)
                          }
                        >
                          <p className="left-him-workflow-coders-card-icon">
                            <img src={userIcon} alt={item?.user_name} />
                          </p>

                          <p className="left-him-workflow-coders-card-name">
                            {`${item?.user_name?.slice(0, 1)?.toUpperCase()}${item?.user_name?.slice(1)}`}
                          </p>

                          <p className="left-him-workflow-coders-card-count">
                            <Tooltip
                              className="him-dashboard-tooltip"
                              title={`${item?.number_of_episodes} Episodes Assigned`}
                            >
                              {`(${item?.number_of_episodes})`}
                            </Tooltip>
                          </p>
                        </div>
                      ))
                    )
                    // ) : (
                    //   sideBarCodersData?.map((item) => (
                    //     <div
                    //       className="left-him-workflow-coders-card-top"
                    //       key={item?.user_id}
                    //       onDragOver={handleDragOver}
                    //       onDrop={(e) =>
                    //         handleDrop(e, item?.user_name, "auditors")
                    //       }
                    //       onClick={() =>
                    //         hanldeSelectQueueEpisodes("auditor", item)
                    //       }
                    //     >
                    //       <p className="left-him-workflow-coders-card-icon">
                    //         <img src={userIcon} alt={item?.user_name} />
                    //       </p>

                    //       <p className="left-him-workflow-coders-card-name">
                    //         {`${item?.user_name?.slice(0, 1)?.toUpperCase()}${item?.user_name?.slice(1)}`}
                    //       </p>

                    //       <p className="left-him-workflow-coders-card-count">
                    //         <Tooltip
                    //           className="him-dashboard-tooltip"
                    //           title={`${item?.number_of_episodes} Auditors Assigned`}
                    //         >
                    //           {`(${item?.number_of_episodes})`}
                    //         </Tooltip>
                    //       </p>
                    //     </div>
                    //   ))
                    // )
                  }
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="right-him-workflow-card">
          {isMobile && (
            <div className="mobile-qc-header">
              <img
                src={backIcon}
                alt="back"
                className="mobile-qc-back-icon"
                onClick={() => navigate("/Code-Workflow")}
              />
              <span className="mobile-qc-back-text">Back to Workflow</span>
            </div>
          )}
          <div className="him-dashboard">
            {healthInformationManagerDashboardsLoading ? (
              <Placeholder
                as={Card.Text}
                animation="glow"
                style={{ width: "100%" }}
              >
                <Placeholder xs={4} className="PlaceholderItem" />{" "}
                <Placeholder xs={4} className="PlaceholderItem" />{" "}
                <Placeholder xs={3} className="PlaceholderItem" />
              </Placeholder>
            ) : (
              // <LdsRoller/>
              codingDashboardOptions?.length > 0 &&
              codingDashboardOptions
                  ?.filter((d) => {
                    if (d.name === "Uncoded & Assigned") {
                      return isUncodedEnabledEnv; // only show this one card if env flag is true
                    }
                    return true;
                  })
              ?.map((dashboardItem) => (
                <div
                  key={dashboardItem?.name}
                  className="him-dashboard-cards"
                  style={{ backgroundColor: dashboardItem?.backgroundColor }}
                >
                  <div className="him-dashboard-cards-top">
                    <p className="him-dashboard-name">
                      {dashboardItem?.name}
                      {/* <Tooltip title={dashboardItem.tooltipContent}>
                      <FontAwesomeIcon icon={faCircleInfo}  className="him-dashboard-tooltip"/>
                    </Tooltip> */}
                    </p>
                    <p className="him-dashboard-icon">
                      <img
                        src={dashboardItem?.icon}
                        alt={dashboardItem?.name}
                      />
                    </p>
                  </div>
                  <p className="him-dashboard-count">{dashboardItem?.count}</p>
                </div>
              ))
            )}
          </div>
          {isMobile && (
            <div className="mobile-view-filter">
              <HealthSideDrawer
                // healthInformationManagerData={healthInformationManagerEpisodesData}
                // healthInformationManagerLoading={
                //   healthInformationManagerEpisodesLoading
                // }
                // healthInformationManagerError={healthInformationManagerEpisodesError}
                handleDragOver={handleDragOver}
                handleDrop={handleDrop}
                hanldeSelectQueueEpisodes={hanldeSelectQueueEpisodes}
              />{" "}
            </div>
          )}

          <div
            className="workflow-him-table-container"
            // style={{ overflowX: "auto" }}
          >
            <div
              className="workflow-him-table-header"
              style={{ cursor: "pointer" }}
            >
              {selectedHimEpisodes?.length > 0 && (
                <Badge
                  className="workflow-him-selected-rows-count-badge him-gap"
                  onClick={() => {
                    setWorkflowHimsAssginModal(true);
                  }}
                >
                  {selectedHimEpisodes?.some(
                    (episode) =>
                      episode?.assigned_user?.includes("Unassigned") &&
                      episode?.assigned_user?.length > 0,
                  )
                    ? "Assign"
                    : "Re-assign"}
                </Badge>
              )}
              <div className="workflow-him-table-header-right-side">
                {/* LEFT: Selected / Total Episodes */}
                <div
                  className="workflow-him-selected-rows-count"
                  style={{ cursor: "pointer" }}
                >
                  <Badge className="workflow-him-selected-rows-count-badge">
                    {selectedHimEpisodes?.length > 0
                      ? `Selected Episodes: ${
                          isAllEpisodesSelected
                            ? healthInformationManagerEpisodesData?.meta
                                ?.total_episode_count
                            : selectedHimEpisodes.length
                        }`
                      : `Total Episodes: ${
                          healthInformationManagerEpisodesData?.meta
                            ?.total_episode_count || 0
                        }`}
                  </Badge>
                </div>

                {/* GAP */}
                <div className="workflow-him-header-spacer" />

                {/* SEARCH */}
                <div className="workflow-him-table-header-search-container">
                  <img
                    src={search_icon}
                    alt="search"
                    style={{ height: "18px", paddingLeft: "5px" }}
                  />

                  <input
                    className="workflow-him-table-header-search-input"
                    value={coderSearchTerm}
                    // searchType === "episode"
                    // ? filtersPayload.episode_identifier_search
                    // : filtersPayload.medical_record_number
                    // }
                    placeholder={
                      searchType === "episode"
                        ? "Search by Episode ID"
                        : "Search by MRN"
                    }
                    onFocus={() => setShowOptions(true)}
                    onBlur={() => setTimeout(() => setShowOptions(false), 150)}
                    onChange={handleSearchEpisode}
                  />

                  {showOptions && (
                    <div className="search-options-dropdown">
                      <div
                        className={`search-option ${searchType === "episode" ? "active" : ""}`}
                        onMouseDown={() => handleSearchTypeChange("episode")}
                      >
                        Search by Episode ID
                      </div>

                      <div
                        className={`search-option ${searchType === "mrn" ? "active" : ""}`}
                        onMouseDown={() => handleSearchTypeChange("mrn")}
                      >
                        Search by MRN
                      </div>
                    </div>
                  )}
                </div>

                {/* FILTERS ICON */}
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => setShowHimFilter(true)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="24px"
                    viewBox="0 -960 960 960"
                    width="24px"
                    fill="#1f1f1f"
                  >
                    <path d="M440-120v-240h80v80h320v80H520v80h-80Zm-320-80v-80h240v80H120Zm160-160v-80H120v-80h160v-80h80v240h-80Zm160-80v-80h400v80H440Zm160-160v-240h80v80h160v80H680v80h-80Zm-480-80v-80h400v80H120Z"></path>
                  </svg>
                </span>

                {/* REFRESH BUTTON */}
                <div
                  className="him-refresh-btn"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    const refreshPayload = {
                      separation_date_from: null,
                      separation_date_to: null,
                      admission_date_from: null,
                      admission_date_to: null,
                      speciality_ids: [],
                      queue_ids: [],
                      priority: [],
                      status_ids: [],
                      coder_ids: [],
                      page_number: 1,
                      page_size: 10,
                      episode_identifier_search: [],
                      los: [],
                      los_op: "",
                      health_fund_contract: [],
                      medical_record_number: [],
                      drg_code: [],
                      sort_by: [],
                      sort_order: [],
                      is_global_search: false,
                    };
                    dispatch(setIsUncodedView(false))
                    setCoderSearchTerm("");
                    dispatch(
                      getHealthInformationQueueManagerEpisodes({
                        storedRole,
                        ...refreshPayload,
                      }),
                    );
                    dispatch(
                      getHealthInformationManagerDashboardOptions({
                        ...refreshPayload,
                        screen_type: storedRole,
                      }),
                    );
                    dispatch(updateFilters(refreshPayload));
                    setSelectedHimEpisodes([]);
                    setIsAllEpisodesSelected(false);
                  }}
                >
                  <img src={RefershIcon} alt="Refresh" />
                </div>
              </div>
            </div>
            <div className="workflow-him-table-body">
              <Table
                // responsive="sm"
                className="workflow-table-Hims"
                style={{ width: "100%" }}
              >
                <thead className="workflow-him-table-thead">
                  <tr className="workflow-him-table-tr">
                    <th className="workflow-him-table-th-select">
                      <input
                        type="checkbox"
                        onChange={hanldeSelectAllHimEpisodes}
                        disabled={episodesData?.length === 0}
                        checked={
                          uncheckedIds.length > 0
                            ? false
                            : isAllEpisodesSelected
                        }
                        className="workflow-him-table-input"
                      />
                    </th>
                    <th
                      className="workflow-him-table-th"
                      onClick={() => handleSort("episode_identifier_search")}
                    >
                      <span>Episode Identifier</span>
                      <span className="episodelist-sort-icon">
                        <Tooltip
                          title={getSortTooltip("episode_identifier_search")}
                          arrow
                        >
                          <span>
                            <FontAwesomeIcon
                              icon={renderSortIcon("episode_identifier_search")}
                            />
                          </span>
                        </Tooltip>
                      </span>
                    </th>
                    <th
                      className="workflow-him-table-th"
                      onClick={() => handleSort("medical_record_number")}
                    >
                      <span>MRN/UR</span>
                      <span className="episodelist-sort-icon">
                        <Tooltip
                          title={getSortTooltip("medical_record_number")}
                          arrow
                        >
                          <span>
                            <FontAwesomeIcon
                              icon={renderSortIcon("medical_record_number")}
                            />
                          </span>
                        </Tooltip>
                      </span>
                    </th>
                    <th
                      className="workflow-him-table-th"
                      onClick={() => handleSort("admission_date")}
                    >
                      <span>Admission Date</span>
                      <span className="episodelist-sort-icon">
                        <Tooltip title={getSortTooltip("admission_date")} arrow>
                          <span>
                            <FontAwesomeIcon
                              icon={renderSortIcon("admission_date")}
                            />
                          </span>
                        </Tooltip>
                      </span>
                    </th>
                    <th
                      className="workflow-him-table-th"
                      onClick={() => handleSort("separation_date")}
                    >
                      <span>Discharge Date</span>
                      <span className="episodelist-sort-icon">
                        <Tooltip
                          title={getSortTooltip("separation_date")}
                          arrow
                        >
                          <span>
                            <FontAwesomeIcon
                              icon={renderSortIcon("separation_date")}
                            />
                          </span>
                        </Tooltip>
                      </span>
                    </th>
                    <th
                      className="workflow-him-table-th"
                      onClick={() => handleSort("length_of_stay")}
                    >
                      <span>LOS</span>
                      <span className="episodelist-sort-icon">
                        <Tooltip title={getSortTooltip("length_of_stay")} arrow>
                          <span>
                            <FontAwesomeIcon
                              icon={renderSortIcon("length_of_stay")}
                            />
                          </span>
                        </Tooltip>
                      </span>
                    </th>
                    <th
                      className="workflow-him-table-th"
                      onClick={() => handleSort("speciality")}
                    >
                      <span>Speciality/Unit</span>
                      <span className="episodelist-sort-icon">
                        <Tooltip title={getSortTooltip("speciality")} arrow>
                          <span>
                            <FontAwesomeIcon
                              icon={renderSortIcon("speciality")}
                            />
                          </span>
                        </Tooltip>
                      </span>
                    </th>
                    <th
                      className="workflow-coder-table-th"
                      onClick={() => handleSort("insurer_identifier")}
                    >
                      <span>Health Fund Contract</span>
                      <span className="episodelist-sort-icon">
                        <Tooltip
                          title={getSortTooltip("insurer_identifier")}
                          arrow
                        >
                          <span>
                            <FontAwesomeIcon
                              icon={renderSortIcon("insurer_identifier")}
                            />
                          </span>
                        </Tooltip>
                      </span>
                    </th>
                    <th
                      className="workflow-auditor-table-th"
                      onClick={() => handleSort("drg_codes")}
                    >
                      <Tooltip title="Provisional DRG">
                        <span>Provisional DRG</span>
                        <span className="episodelist-sort-icon">
                          <Tooltip title={getSortTooltip("drg_codes")} arrow>
                            <span>
                              <FontAwesomeIcon
                                icon={renderSortIcon("drg_codes")}
                              />
                            </span>
                          </Tooltip>
                        </span>
                      </Tooltip>
                    </th>
                    <th
                      className="workflow-auditor-table-th"
                      onClick={() => handleSort("weight")}
                    >
                      <span>Provisional Account Revenue</span>
                      <span className="episodelist-sort-icon">
                        <Tooltip title={getSortTooltip("weight")} arrow>
                          <span>
                            <FontAwesomeIcon icon={renderSortIcon("weight")} />
                          </span>
                        </Tooltip>
                      </span>
                    </th>
                    <th
                      className="workflow-him-table-th"
                      onClick={() => handleSort("queue")}
                    >
                      <span>Current Queue</span>
                      <span className="episodelist-sort-icon">
                        <Tooltip title={getSortTooltip("queue")} arrow>
                          <span>
                            <FontAwesomeIcon icon={renderSortIcon("queue")} />
                          </span>
                        </Tooltip>
                      </span>
                    </th>
                    <th
                      className="workflow-him-table-th"
                      onClick={() => handleSort("assigned_user")}
                    >
                      <span>Assigned User</span>
                      <span className="episodelist-sort-icon">
                        <Tooltip title={getSortTooltip("assigned_user")} arrow>
                          <span>
                            <FontAwesomeIcon
                              icon={renderSortIcon("assigned_user")}
                            />
                          </span>
                        </Tooltip>
                      </span>
                    </th>
                    <th
                      className="workflow-him-table-th"
                      onClick={() => handleSort("queue_priority")}
                    >
                      <span>Priority</span>
                      <span className="episodelist-sort-icon">
                        <Tooltip title={getSortTooltip("queue_priority")} arrow>
                          <span>
                            <FontAwesomeIcon
                              icon={renderSortIcon("queue_priority")}
                            />
                          </span>
                        </Tooltip>
                      </span>
                    </th>
                    <th
                      className="workflow-him-table-th"
                      onClick={() => handleSort("status")}
                    >
                      <span>Status</span>
                      <span className="episodelist-sort-icon">
                        <Tooltip title={getSortTooltip("status")} arrow>
                          <span>
                            <FontAwesomeIcon icon={renderSortIcon("status")} />
                          </span>
                        </Tooltip>
                      </span>
                    </th>
                    {(codebookcoblhEnv||codebookdevEnv) && !isUncodedView &&<th className="workflow-coder-table-th">
                    <span>CDQ</span>
                  </th>}
                  </tr>
                </thead>
                <tbody className="workflow-him-table-body">
                  {/* {HimFilterTableData ? (
                  <td colspan="10">
                    <div className="episodelist-table-loader">
                      <Spinner />{" "}
                    </div>
                  </td>
                ) : episodesFilterListError ? (
                  <td colspan="10">
                    <div className="episodelist-table-loader1">
                      {episodesFilterListError}
                    </div>
                  </td>
                ) : dataToDisplay?.length > 0 ? ( */}
                  {healthInformationManagerEpisodesLoading ? (
                    <td colspan="10">
                      <div className="workflow-him-table-loader">
                        <LdsRoller />
                      </div>
                    </td>
                  ) : healthInformationManagerEpisodesError ? (
                    <td colspan="15">
                      <div className="workflow-him-table-error">
                        No data found
                      </div>
                    </td>
                  ) : dataToDisplay?.length > 0 ? (
                    dataToDisplay?.map((HimTableItem) => {
                      const PRIORITY_STYLES = {
                        URGENT: {
                          bg: "#FDF2FA",
                          border: "#FCCEEE",
                          color: "#C11574",
                        },
                        HIGH: {
                          bg: "#FEF6EE",
                          border: "#F9DBAF",
                          color: "#D28800",
                        },
                        LOW: {
                          bg: "#F9FAFB",
                          border: "#EAECF0",
                          color: "#344054",
                        },
                        OVERDUE: {
                          bg: "#FEFCE8",
                          border: "#F9DBAF",
                          color: "#344054",
                        },
                        MEDIUM: {
                          bg: "#FEFCE8",
                          border: "#F9DBAF",
                          color: "#344054",
                        },
                      };
                      const activePriority = Array.isArray(
                        HimTableItem?.priority,
                      )
                        ? HimTableItem.priority.find(
                            (p) => PRIORITY_STYLES[p],
                          ) || ""
                        : PRIORITY_STYLES[HimTableItem?.priority]
                          ? HimTableItem.priority
                          : "";

                      const styles = PRIORITY_STYLES[activePriority] || {};
                      return (
                        <tr
                          key={HimTableItem?.hcp_line_id}
                          // style={{ borderBottom: "1px solid #E5E7EB" }}
                          draggable
                          onDragStart={(e) => handleDragStart(e, HimTableItem)}
                          className="workflow-him-table-tr"
                          // onDoubleClick={() => {
                          //   navigate("/coder");
                          //   dispatch(
                          //     resetEpisodeIdentifierTopassDocumentViewer()
                          //   );
                          //   dispatch(resetDocumentViewerLoadedData());
                          //   dispatch(selectedEpisodeList(episode));
                          //   dispatch(resetDocumentViewerError());
                          // }}
                        >
                          <td className="workflow-him-table-td">
                            <input
                              type="checkbox"
                              className="workflow-him-table-input"
                              disabled={HimTableItem.is_locked}
                              checked={selectedHimEpisodes?.some(
                                (episode) =>
                                  episode?.hcp_line_id ===
                                  HimTableItem?.hcp_line_id,
                              )}
                              onChange={(e) =>
                                handleHimRowSelection(e, HimTableItem)
                              }
                            />
                          </td>
                          <td className="workflow-him-table-td">
                            <div style={{ padding: "7px 10px" }}>
                              {/* {HimTableItem.is_locked && <LockOutlineIcon  style={{ fontSize: "18px" , marginRight:"8px" }}/>}            */}
                              {HimTableItem.is_locked && (
                                <LockOutlineIcon
                                  style={{
                                    fontSize: "18px",
                                    marginRight: "8px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() =>
                                    handleUnlockEpisode(
                                      HimTableItem.hcp_line_id,
                                    )
                                  }
                                />
                              )}
                              <Tooltip title={HimTableItem.episode_identifier}>
                                {getHighlightedText(
                                  HimTableItem?.episode_identifier,
                                )}
                              </Tooltip>
                            </div>
                          </td>
                          <td className="workflow-him-table-td">
                            <div style={{ padding: "7px 10px" }}>
                              {HimTableItem?.medical_record_number}
                            </div>
                          </td>
                          <td className="workflow-him-table-td">
                            <div style={{ padding: "7px 10px" }}>
                              {HimTableItem?.admission_date}
                            </div>
                          </td>
                          <td className="workflow-him-table-td">
                            <div style={{ padding: "7px 10px" }}>
                              {HimTableItem?.separation_date !== null
                                ? HimTableItem?.separation_date
                                : "-"}
                            </div>
                          </td>
                          <td className="workflow-him-table-td">
                            <div style={{ padding: "7px 10px" }}>
                              {HimTableItem?.length_of_stay}
                            </div>
                          </td>
                          <td className="workflow-him-table-td">
                            <div style={{ padding: "7px 10px" }}>
                              {HimTableItem?.speciality
                                ? HimTableItem?.speciality
                                : "-"}
                            </div>
                          </td>
                          <td className="workflow-him-table-td">
                            <div style={{ padding: "7px 10px" }}>
                              {HimTableItem?.health_fund_contract
                                ? HimTableItem?.health_fund_contract
                                : "-"}
                            </div>
                          </td>
                          <td className="workflow-auditor-table-td">
                            {(() => {
                              const drgs = HimTableItem?.drg_code || [];
                              if (!drgs.length) return "-";
                              const defaultDrg =
                                drgs.find((drg) => drg.is_default) || drgs[0];
                              const remainingDrgs = drgs.filter(
                                (drg) => drg !== defaultDrg && drg.drg_code,
                              );
                              if (!drgs?.length) return "-";
                              const selectedIndex = getSelectedDrgIndex(
                                HimTableItem.hcp_line_id,
                              );
                              const selectedDrg = drgs[selectedIndex];
                              return (
                                <div style={{ padding: "7px 10px" }}>
                                  {/* Selected DRG (row-level hover tooltip) */}
                                  <Tooltip
                                    title={
                                      <>
                                        <div>
                                          <b>Grouper Version:</b>{" "}
                                          {defaultDrg.grouper_version}
                                        </div>
                                        <div>
                                          <b>Weight:</b> {defaultDrg.weight}
                                        </div>
                                      </>
                                    }
                                    arrow
                                  >
                                    {/* <span
                                                                  style={{ cursor: "pointer", fontWeight: 500 }}
                                                                  onClick={(e) => openDrgMenu(e, HimTableItem.hcp_line_id)}
                                                                >
                                                                  {selectedDrg.drg_code}
                                                                </span> */}
                                    <span
                                      style={{
                                        cursor: "pointer",
                                        fontWeight: 500,
                                        display: "inline-flex",
                                        alignItems: "center",
                                        gap: "2px",
                                      }}
                                      onClick={(e) =>
                                        openDrgMenu(e, HimTableItem.hcp_line_id)
                                      }
                                    >
                                      {defaultDrg.drg_code}
                                      {drgs?.length > 1 && (
                                        <ArrowDropDownIcon fontSize="small" />
                                      )}
                                    </span>
                                  </Tooltip>

                                  {/* Dropdown */}
                                  <Menu
                                    anchorEl={drgAnchorEl}
                                    open={
                                      Boolean(drgAnchorEl) &&
                                      activeDrgRow === HimTableItem.hcp_line_id
                                    }
                                    onClose={closeDrgMenu}
                                  >
                                    {remainingDrgs.map((drg, index) => (
                                      <Tooltip
                                        key={index}
                                        title={
                                          <>
                                            <div>
                                              <b>Version:</b>{" "}
                                              {drg.grouper_version}
                                            </div>
                                            <div>
                                              <b>Weight:</b> {drg.weight}
                                            </div>
                                          </>
                                        }
                                        placement="right"
                                        arrow
                                      >
                                        <MenuItem
                                          onClick={() => {
                                            updateSelectedDrgIndex(
                                              HimTableItem.hcp_line_id,
                                              index,
                                            );
                                            closeDrgMenu();
                                          }}
                                        >
                                          {drg.drg_code}
                                        </MenuItem>
                                      </Tooltip>
                                    ))}
                                  </Menu>
                                </div>
                              );
                            })()}
                          </td>
                          <td className="workflow-him-table-td">
                            {(() => {
                              const drgs = HimTableItem?.drg_code || [];
                              if (!drgs.length) return "-";

                              const defaultDrg =
                                drgs.find((drg) => drg.is_default) || drgs[0];

                              if (!drgs?.length) return "-";

                              return (
                                <div style={{ padding: "7px 10px" }}>
                                  <span>
                                    ${" "}
                                    {Math.round(
                                      defaultDrg.weight * 7258,
                                    ).toLocaleString()}
                                  </span>
                                </div>
                              );
                            })()}
                          </td>
                          <td className="workflow-him-table-td">
                            <div style={{ padding: "7px 10px" }}>
                              {HimTableItem?.queue?.length > 0
                                ? (() => {
                                    const queueNames = HimTableItem.queue
                                      .filter((q) => q?.queue_name)
                                      .map((q) => q.queue_name);

                                    const MAX_ITEMS = 2; // how many to show before "..."
                                    const visibleItems = queueNames.slice(
                                      0,
                                      MAX_ITEMS,
                                    );
                                    const hasMore =
                                      queueNames.length > MAX_ITEMS;

                                    return (
                                      <Tooltip
                                        title={
                                          <div style={{ padding: "4px 8px" }}>
                                            {queueNames.map((name, index) => (
                                              <div key={index}>• {name}</div>
                                            ))}
                                          </div>
                                        }
                                        arrow
                                        placement="top"
                                      >
                                        <div
                                          style={{
                                            cursor: "pointer",
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            maxWidth: "180px",
                                          }}
                                        >
                                          {visibleItems.map((name, index) => (
                                            <span key={index}>
                                              • {name}
                                              {index <
                                                visibleItems.length - 1 && " "}
                                            </span>
                                          ))}
                                          {hasMore && " ..."}
                                        </div>
                                      </Tooltip>
                                    );
                                  })()
                                : "-"}
                            </div>
                          </td>
                          <td className="workflow-him-table-td">
                            <div style={{ padding: "7px 10px" }}>
                              {HimTableItem?.assigned_user
                                ? HimTableItem?.assigned_user?.map(
                                    (item) => item.is_primary && item.user_name,
                                  )
                                : "-"}
                            </div>
                          </td>
                          <td className="workflow-him-table-td">
                            <div style={{ padding: "7px 10px" }}>
                              {HimTableItem?.priority &&
                              HimTableItem?.priority?.length > 0 ? (
                                <Badge
                                  className="workflow-him-priority"
                                  bg={null}
                                  style={{
                                    backgroundColor: styles.bg,
                                    border: `1px solid ${styles.border}`,
                                    color: styles.color,
                                    padding: "5px 10px",
                                    borderRadius: "12px",
                                    fontSize: "12px",
                                  }}
                                >
                                  {activePriority === "NIL ASSIGNED"
                                    ? ""
                                    : activePriority || "-"}
                                </Badge>
                              ) : (
                                "-"
                              )}
                            </div>
                          </td>
                          <td className="workflow-auditor-table-td">
                            {Array.isArray(HimTableItem?.status) &&
                            HimTableItem.status.length > 0
                              ? (() => {
                                  const list = HimTableItem.status.filter(
                                    (s) => s?.status,
                                  );
                                  const topStatus = list?.filter(
                                    (item) => item?.is_primary,
                                  );
                                  const statusText =
                                    topStatus?.map((item) => item.status) ??
                                    "-";
                                  const hasMultiple = list.length > 1;

                                  const getColor = (statusText) => {
                                    const status = statusText[0];
                                    switch (status) {
                                      case "Audit - AI processing complete - codes available for validation":
                                        return "#4CAF50";
                                      case "Audit - Audited":
                                        return "#2E7D32";
                                      case "Audit - Awaiting Audit":
                                      case "Awaiting Audit":
                                        return "#FFA726";
                                      case "Audit - Awaiting CDQ":
                                        return "#FFB300";
                                      case "Audit - CDQ For Review":
                                        return "#FB8C00";
                                      case "Audit - Coding Complete":
                                        return "#00897B";
                                      case "Audit - Locked by user":
                                        return "#757575";
                                      case "Audit - Missing Notes":
                                        return "#E53935";
                                      case "Audit - On Hold":
                                        return "#6A1B9A";
                                      case "Audit - Outstanding":
                                        return "#F44336";
                                      default:
                                        return "#344054";
                                    }
                                  };

                                  return (
                                    <Tooltip
                                      title={
                                        <div style={{ padding: "4px 8px" }}>
                                          {list.map((item, index) => (
                                            <div key={index}>{item.status}</div>
                                          ))}
                                        </div>
                                      }
                                      arrow
                                      placement="top"
                                    >
                                      <Box
                                        sx={{
                                          position: "relative",
                                          width: "180px",
                                          cursor: "pointer",
                                        }}
                                      >
                                        {/* stacked layers */}
                                        {hasMultiple &&
                                          list
                                            .slice(1, 3)
                                            .map((item, index) => (
                                              <Box
                                                key={index}
                                                sx={{
                                                  position: "absolute",
                                                  top: `${(index + 1) * 4}px`,
                                                  left: `${(index + 1) * 4}px`,
                                                  width: "100%",
                                                  height: "34px",
                                                  borderRadius: "6px",
                                                  backgroundColor: "#E0E0E0",
                                                  zIndex: index,
                                                }}
                                              />
                                            ))}

                                        {/* top status */}
                                        <Box
                                          sx={{
                                            position: "relative",
                                            zIndex: 1,
                                            backgroundColor: "#FFF",
                                            color: getColor(statusText),
                                            border: "1px solid #D0D5DD",
                                            borderRadius: "6px",
                                            fontSize: "12px",
                                            fontWeight: "600",
                                            padding: "6px 8px",
                                            textAlign: "center",
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            boxShadow:
                                              "0 2px 6px rgba(0,0,0,0.1)",
                                          }}
                                        >
                                          {statusText}
                                        </Box>

                                        {/* +count badge */}
                                        {list.length > 3 && (
                                          <Box
                                            sx={{
                                              position: "absolute",
                                              bottom: "-6px",
                                              right: "-6px",
                                              background: "#344054",
                                              color: "#fff",
                                              fontSize: "10px",
                                              borderRadius: "10px",
                                              px: "5px",
                                              py: "1px",
                                            }}
                                          >
                                            +{list.length - 1}
                                          </Box>
                                        )}
                                      </Box>
                                    </Tooltip>
                                  );
                                })()
                              : "-"}
                          </td>
                        {(codebookcoblhEnv||codebookdevEnv) && !isUncodedView &&<td className="workflow-him-table-td">
                        {HimTableItem?.cdq_count > 0 ? (
                          <span
                            className="workflow-him-cdq-view"
                            style={{
                              color: "#175CD3",
                              fontWeight: 500,
                              fontSize: "13px",
                              cursor: "pointer",
                              display: "inline-flex",
                              alignItems: "center",
                              gap: "4px",
                              whiteSpace: "nowrap",
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleViewCdqResponses(HimTableItem);
                            }}
                          >
                            View ({HimTableItem.cdq_count})
                          </span>
                        ) : (
                          "-"
                        )}
                      </td>}
                        </tr>
                      );
                    })
                  ) : (
                    <td colspan="10">
                      <div className="workflow-him-table-no-records">
                        No Records Found
                      </div>
                    </td>
                  )}
                </tbody>
              </Table>
            </div>
            <div className="HimTable-footer">
              <div>
                <Pagination className="HimTable-pagination">
                  <Pagination.First
                    className="HimTable-pagination-li"
                    onClick={() => handlePageChange(1)}
                    disabled={filtersPayload?.page_number <= 1}
                  />
                  <Pagination.Prev
                    onClick={() =>
                      handlePageChange(filtersPayload?.page_number - 1)
                    }
                    disabled={filtersPayload?.page_number <= 1}
                    className="HimTable-prev-btn"
                  />
                  <Pagination.Item className="HimTable-pagination-li">
                    Page {filtersPayload?.page_number} of {totalPages}
                  </Pagination.Item>

                  <Pagination.Next
                    onClick={() =>
                      handlePageChange(filtersPayload?.page_number + 1)
                    }
                    disabled={filtersPayload?.page_number >= totalPages}
                    className="HimTable-next-btn"
                  />
                  <Pagination.Last
                    className="HimTable-pagination-li"
                    onClick={() => handlePageChange(totalPages)}
                    disabled={filtersPayload?.page_number === totalPages}
                  />
                </Pagination>
              </div>
              <div className="HimTable-row-options">
                <Form.Select
                  className="HimTable-select"
                  value={filtersPayload?.page_size}
                  onChange={handleRowsPerPageChange}
                >
                  <option
                    value=""
                    disabled
                    className="HimTable-rows-per-page_number"
                  >
                    Rows per page
                  </option>
                  {/* <option value={1} className="HimTable-rows-per-page">
                  1
                </option>
                <option value={2} className="HimTable-rows-per-page">
                  2
                </option>
                <option value={5} className="HimTable-rows-per-page">
                  5
                </option> */}
                  <option value={10} className="HimTable-rows-per-page">
                    10
                  </option>
                  <option value={20} className="HimTable-rows-per-page">
                    20
                  </option>
                  <option value={50} className="HimTable-rows-per-page">
                    50
                  </option>
                </Form.Select>
              </div>
            </div>
          </div>
        </div>

        {workflowHimsAssginModal && (
          <HealthInformationManagerAssignModal
            workflowHimsAssginModal={workflowHimsAssginModal}
            setWorkflowHimsAssginModal={setWorkflowHimsAssginModal}
            selectedRecord={selectedRecord}
            isAllEpisodesSelected={isAllEpisodesSelected}
            selectedHimEpisodes={selectedHimEpisodes}
            handleHimSelectChange={handleHimSelectChange}
            setCoderSearchTerm = {setCoderSearchTerm}
            uncheckedIds={uncheckedIds}
          />
        )}

        <HimManagerFilter
          show={showHimFilter}
          setShowHimFilter={setShowHimFilter}
          onClose={handleModalClose}
          setCoderSearchTerm={setCoderSearchTerm}
          selectedCoderOptions={selectedCoderOptions}
        />
        <CdqResponseHistoryModal
                show={showCdqModal}
                onClose={handleCloseCdqModal}
                loading={loadingCdqHistoryData}
                error={errorCdqHistoryData}
                episodeIdentifier={selectedCdqRecord?.episode_identifier}
                 totalCount={cdqHistoryData?.count_cdq_response}
                  currentPage={cdqPageNumber}
                  onPageChange={handleCdqPageChange}
                // onLoadMore={handleLoadMoreCdqResponses}
                 responses={cdqHistoryData?.cdq_responses || []}
              />
      </div>
    </>
  );
};

export default HealthInformationManager;
